exports = module.exports = require("../../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._15WAv8iqU1KFyrER15Ml9L{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-line-pack:center;align-content:center}", ""]);
// Exports
exports.locals = {
	"n-toolbarImageWrapper": "_15WAv8iqU1KFyrER15Ml9L"
};